import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M42 28a2 2 0 012 2v12a2 2 0 11-4 0l.001-5.997A19.986 19.986 0 0124 44a19.94 19.94 0 01-14.142-5.858 2 2 0 112.828-2.828A15.94 15.94 0 0024 40a15.995 15.995 0 0013.86-8H30a2 2 0 110-4h12zM24 4a19.94 19.94 0 0114.142 5.858 2 2 0 11-2.828 2.828A15.94 15.94 0 0024 8a15.995 15.995 0 00-13.86 8H18a2 2 0 110 4H6a2 2 0 01-2-2V6a2 2 0 114 0v5.996A19.986 19.986 0 0124 4z",
  fill: "#262626"
}));

var SvgCleanRecurringXLarge = function SvgCleanRecurringXLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgCleanRecurringXLarge;